import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';
import WarningBlock from '../../../components/warningBlock';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='HIIT / Plyometrics' second='Workout 02' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: 'FULLBODY / HIT',
							value: 'High Knees',
						},
						{
							header: 'REPS',
							value: '20',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Curl into Shoulder Press w / (DB)',
						},
						{
							header: 'REPS',
							value: '15',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Squat Jumps',
						},
						{
							header: 'REPS',
							value: '8',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Plank Jacks',
						},
						{
							header: 'REPS',
							value: '10',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Leg Tucks w / (Pull Up Bar)',
						},
						{
							header: 'REPS',
							value: '10',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
